import {css} from 'lit';
export const styles = css`/* NOTE: Trix-editor is in slot so all stiles are external */

:host {
  display: block;
  min-width: 200px;
}
`;
export default styles;
